var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HtmlMuniSelector } from "../html-elements/module";
import { ChartMap } from "../svg-elements/module";
import * as d3 from "d3";
import * as topojson from "topojson-client";
import { slugify } from "../d3-services/_helpers";
import { GraphControllerV2 } from "./graph-v2";
var MuniSelector = /** @class */ (function (_super) {
    __extends(MuniSelector, _super);
    function MuniSelector(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    MuniSelector.prototype.pre = function () {
        this._addMargin(0, 0, 0, 0);
        this._addPadding(0, 0, 0, 0);
    };
    MuniSelector.prototype.init = function () {
        var _this = this;
        var self = this;
        _super.prototype._init.call(this);
        var orig_el = this.element;
        var map_container = document.createElement('div');
        map_container.style.height = '240px';
        map_container.style.width = '240px';
        map_container.style.position = 'absolute';
        map_container.style.left = '-50px';
        map_container.style.top = '70px';
        this.element.appendChild(map_container);
        _super.prototype._svg.call(this, map_container);
        this.map = new ChartMap(this);
        var dropdown_container = document.createElement('div');
        dropdown_container.style.position = "relative";
        dropdown_container.style.marginTop = "160px";
        var muniSelector = new HtmlMuniSelector(dropdown_container, 'gemeente_pagina');
        muniSelector.draw(this.segment);
        orig_el.appendChild(dropdown_container);
        var municipalitySelect = document.querySelector('.municipality_select_' + 'gemeente_pagina');
        municipalitySelect.addEventListener("change", function () {
            var new_muni = municipalitySelect.options[municipalitySelect.selectedIndex].value;
            window.location.href = window.location.origin + window.location.pathname + '?topic=gemeente&gemeente=' + new_muni;
        });
        d3.json('https://img.publikaan.nl/geojson/gemeenten2021.topojson').then(function (topojsonObject) {
            self.topojsonObject = topojsonObject;
            _this.update(_this.data, _this.segment, false);
        });
    };
    MuniSelector.prototype.prepareData = function (data) {
        var geojson = topojson.feature(this.topojsonObject, this.topojsonObject.objects.gemeenten);
        var features = geojson.features;
        var _loop_1 = function (feature) {
            var muni = data.filter(function (m) {
                return m.gemeente === slugify(feature.properties.gemeentenaam).toLowerCase();
            })[0];
        };
        for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
            var feature = features_1[_i];
            _loop_1(feature);
        }
        return features;
    };
    MuniSelector.prototype.draw = function (data) {
        this.map.draw(data);
    };
    MuniSelector.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        this.map.redraw(false, 'orange');
        this.map.highlight(this.segment);
    };
    MuniSelector.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return MuniSelector;
}(GraphControllerV2));
export default MuniSelector;
